import React, { useEffect, useRef, useState } from "react";
import viewBg from "assets/images/common/others/viewBg.png";
import { ReactComponent as DeleteIconSvg } from "assets/images/common/svgs/delete.svg";
import { ReactComponent as ArrowBackIcon } from "assets/images/common/svgs/arrow_back.svg";
import { ReactComponent as ArrowDownIcon } from "assets/images/common/svgs/ArrowDownIcon.svg";
import attendeImg from "assets/images/common/others/minorImage.png";
import eventImage from "assets/images/common/others/exploreEvents.png";
import editProfilePicUser from "assets/images/common/others/editProfileUSer.png";

import ProfileUSer from "assets/images/common/others/profile-user-img.png";
import { useNavigate } from "react-router-dom";
import PersonalInformation from "./component/PersonalInformation";
import { siteRoutes } from "utils/helpers/enums/routes.enum";
import FavoriteHost from "./component/FavouriteHost";
import DigitalPassport from "./component/DigitalPassport";
import TicketPass from "./component/TicketPass";
import useUsers from "containers/user-management/useHooks";
import useUtils from "hooks/useUtils";
import { useSelector } from "react-redux";
import { concatPathWithBackendUrl } from "utils/helpers/urlHelper";
import DataNotFound from "components/particles/table/data-not-found";
import { EventsFilterDTO } from "utils/helpers/models/users/events-filter.dto";
import { EVENT_STATUS } from "utils/helpers/enums/shared.enum";

interface Tab {
  name: string;
  Component: JSX.Element;
}


const ViewMinors = () => {
  const [user, setUser] = useState<any>({});

  const tabs: Tab[] = [
    { name: "Personal Information", Component: <PersonalInformation user={user} /> },
    { name: "Digital Passport", Component: <DigitalPassport minorId={user?.user?.id} /> },
    // { name: "Favorite Hosts", Component: <FavoriteHost /> },
    { name: "Ticket Pass", Component: <TicketPass Id={user?.user?.id} /> },
  ];

  const [activeTab, setActiveTab] = useState<Tab>(tabs[0]);
  const { getUserById, getEventByUserID } = useUsers();
  const { getQueryParams } = useUtils();
  const { isLoading } = useSelector((state: any) => state.sharedReducer);
  const params = getQueryParams();
  console.log(params?.id)
  const [filters, setFilters] = useState<EventsFilterDTO>(
    new EventsFilterDTO()
  );
  const navigate = useNavigate();

  useEffect(() => {
    getUserById(params?.id, setUser);
  }, []);

  const formatDateTime = (dateTimeString: string): string => {
    const date = new Date(dateTimeString);
    const day = date.getDate();
    const monthNames = [
      "January", "February", "March", "April", "May", "June",
      "July", "August", "September", "October", "November", "December"
    ];
    const month = monthNames[date.getMonth()];
    const year = date.getFullYear();

    let hours = date.getHours();
    const minutes = date.getMinutes();
    const ampm = hours >= 12 ? "PM" : "AM";
    hours = hours % 12;
    hours = hours ? hours : 12;

    const minuteStr = minutes < 10 ? `0${minutes}` : minutes;

    return `${day} ${month} ${year} at ${hours}.${minuteStr} ${ampm}`;
  };


  const [data, setData] = useState<any[]>([]);

  console.log(user?.user?.id,)

  useEffect(() => {
    if (user?.user?.id) {
      getEventByUserID(
        { childId: user?.user?.id, status: EVENT_STATUS.JOINED },
        setData
      );
    }
  }, [user?.user?.id,]);


  const goToBack = () => {
    navigate(-1);
  };


  const goToAllEvent = (id: number, user: any) => {
    navigate(`${siteRoutes.minorEvents}?id=${id}`, { state: { user } });
  };

  const goToEventDetail = (id: number, user: any) => {
    navigate(`${siteRoutes.minorEventsDetail}?id=${id}`, { state: { user } });
  };

  return (
    <div className="pb-5">
      <div className="flex justify-between items-center gap-4 mb-6">
        <h1 className="text-base text-primaryText font-bold  flex items-center gap-3">
          <span
            onClick={goToBack}
            className="bg-transparentBlueBg w-[44px] h-[44px] rounded-full flex items-center justify-center cursor-pointer"
          >
            <ArrowBackIcon />
          </span>
          {`${user?.user?.firstName} ${user?.user?.lastName}`}’s Profile
        </h1>
        {/* <div className="flex items-center gap-6">
          <span className="flex items-center gap-2">
            <p className="text-sm font-bold text-primaryText">Block User</p>
            <label className="switch-field-small">
              <input type="checkbox" />
              <span className="slider"></span>
            </label>
          </span>
          <span className="flex items-center gap-2">
            <p className="text-sm font-bold text-redtext">Delete User</p>
            <DeleteIconSvg />
          </span>
        </div> */}
      </div>
      <div className="flex flex-wrap lg:flex-nowrap gap-4 ">
        <div className="bg-white border-[0.3px] border-mediumGrayBorder rounded-lg min-w-[286px] max-w-[286px]">
          <div className="flex justify-center items-center gap-2 p-6">
            <span>
              <img
                className="w-[82px] h-[82px] rounded-full"
                src={
                  user?.user?.profilePicUrl
                    ? concatPathWithBackendUrl(
                      user?.user?.profilePicUrl?.fileDownloadUri
                    )
                    : editProfilePicUser
                }
              />
            </span>
            <span>
              <h2 className="text-base whitespace-nowrap font-bold text-primaryText">
                {`${user?.user?.firstName} ${user?.user?.lastName}`}
              </h2>
              <p className="text-xs font-medium text-primaryText">
                {user?.profiles?.child?.attendee?.lastName} family
              </p>
            </span>
          </div>
          <div className="">
            <div className=" w-full">
              {data.slice(0, 4).map((exp: any, index: number) => (
                <div
                  onClick={() => goToEventDetail(exp?.id, user)}
                  key={index + 1}
                  className="p-6 border-t border-lightBorder last:border-b-0 cursor-pointer"
                >
                  <div className="flex justify-center gap-2 items-start ">
                    <div className="min-w-10 min-h-10">
                      <img
                        className="w-10 h-10 rounded-full object-cover"
                        src={concatPathWithBackendUrl(
                          exp.eventPicsUrl![0]?.fileDownloadUri
                        )}
                        alt="eventImage"
                      />
                    </div>
                    <div>
                      <h3 className="font-bold text-primaryText text-sm">
                        {exp.title}
                      </h3>

                      <p className="font-medium text-primaryText text-xs">
                        {exp.workshopSessions && exp.workshopSessions.length > 0 && formatDateTime(exp.workshopSessions[0].startDateTime)}
                      </p>

                      <p className="font-medium text-primaryText text-xs">
                        {exp.location}
                      </p>
                      <p className="font-medium text-primaryText text-xs">
                        {exp.city}
                      </p>

                      {/* <div className="flex justify-start items-center mt-2">
                        {event.attendees.slice(0, 2).map((attendee) => (
                          <img
                            key={attendee.id}
                            src={attendee.avatar}
                            alt={attendee.name}
                            className="w-8 h-8 rounded-full border-2 border-white mr-2"
                          />
                        ))}
                        {event.attendees.length > 2 && (
                          <div className="w-7 h-7 flex items-center justify-center rounded-full border border-lightBlueColor text-lightBlueColor text-sm bg-white ">
                            +{event.attendees.length - 2}
                          </div>
                        )}
                      </div> */}
                    </div>
                  </div>
                </div>
              ))}

            </div>
            {data.length > 4 && (
              <div className="flex justify-center pb-6 px-6">
                <button
                  onClick={() => goToAllEvent(user?.user?.id, user)}
                  className="bg-skyLightBg text-sm font-bold px-4 py-2 rounded-lg"
                >
                  See More
                </button>
              </div>
            )}
            <div className="">
              <DataNotFound show={!isLoading && !data.length} />
            </div>
          </div>
        </div>
        <div className="bg-white border-[0.3px] border-mediumGrayBorder rounded-lg p-6 w-full">
          <div className=" flex flex-wrap gap-4">
            {tabs.map((tab) => (
              <button
                key={tab.name}
                className={`rounded-md px-3 py-2 font-medium text-xs transition-colors duration-300 ${activeTab.name === tab.name
                  ? "bg-vibrantBlueBg text-white "
                  : "bg-warmOffWhiteBg text-mediumGrayText"
                  }`}
                onClick={() => setActiveTab(tab)}
              >
                {tab.name}
              </button>
            ))}
          </div>
          <div className="mt-4">{activeTab.name === "Personal Information" ? (
            <PersonalInformation user={user} />
          ) : activeTab.name === "Digital Passport" ? (
            <DigitalPassport minorId={user?.user?.id} />
          ) : activeTab.name === "Favorite Hosts" ? (
            <FavoriteHost />
          ) : activeTab.name === "Ticket Pass" ? (
            <TicketPass Id={user?.user?.id} />
          ) : null}</div>
        </div>
      </div>
    </div>
  );
};

export default ViewMinors;
